import React from "react";

import { gradeLevelList, gradeLevelMeta } from "@examspark/common-meta";
import { SelectInput } from "@examspark/common-ui";

export const GradeLevelSelect = (
  props: Omit<
    React.ComponentProps<typeof SelectInput.Simple>,
    "options" | "placeholder"
  >,
) => {
  return (
    <SelectInput.Simple
      {...props}
      options={gradeLevelList.map((s) => ({
        label: gradeLevelMeta[s]?.label,
        value: s,
      }))}
      placeholder="Select Grade..."
    ></SelectInput.Simple>
  );
};
